import React, { useState, useEffect } from 'react';
import { Search, X, UserPlus, CheckCircle, AlertCircle, Users } from 'lucide-react';
import API_URL from '../config/ApiUrl';
import { useTheme } from '../arrangement/ThemeContext';
const InviteUsersModal = ({ isOpen, onClose, currentRoom, currentUser, onInviteSuccess }) => {
    console.log('CALLLEDDDD')
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [inviting, setInviting] = useState({});
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState('');

  const { colors } = useTheme();
  

  useEffect(() => {
    if (isOpen) {
      setSearchQuery('');
      setSearchResults([]);
      setError(null);
      setSuccess('');
    }
  }, [isOpen]);

  // Debounced search
  useEffect(() => {
    if (searchQuery.length >= 2) {
      const timeoutId = setTimeout(() => searchUsers(), 300);
      return () => clearTimeout(timeoutId);
    } else {
      setSearchResults([]);
    }
  }, [searchQuery]);

  const searchUsers = async () => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await fetch(`${API_URL}/api/users/search?q=${encodeURIComponent(searchQuery)}&room_id=${currentRoom.id}`, {
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        // Filter out users who already have membership
        const availableUsers = data.users.filter(user => 
          !user.membership_in_room || 
          !['creator', 'admin', 'member', 'viewer', 'invited', 'pending'].includes(user.membership_in_room)
        );
        setSearchResults(availableUsers);
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Failed to search users');
      }
    } catch (err) {
      setError('Failed to search users');
    } finally {
      setLoading(false);
    }
  };

  const inviteUser = async (userId, username) => {
    setInviting(prev => ({ ...prev, [userId]: true }));
    setError(null);
    
    try {
      const response = await fetch(`${API_URL}/api/rooms/${currentRoom.id}/invite`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          user_id: userId,
          membership_type: 'invited'
        })
      });
      
      if (response.ok) {
        const data = await response.json();
        setSuccess(`${username} has been invited to the room!`);
        setSearchResults(prev => prev.filter(user => user.id !== userId));
        
        if (onInviteSuccess) {
          onInviteSuccess(data);
        }
        
        setTimeout(() => setSuccess(''), 3000);
      } else {
        const errorData = await response.json();
        setError(errorData.error || 'Failed to invite user');
      }
    } catch (err) {
      setError('Failed to invite user');
    } finally {
      setInviting(prev => ({ ...prev, [userId]: false }));
    }
  };

  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10000,
      padding: '20px'
    }}>
      <div style={{
        backgroundColor: '#1a1a1a',
        borderRadius: '16px',
        padding: '24px',
        maxWidth: '500px',
        width: '100%',
        maxHeight: '80vh',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #333',
        color: 'white'
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '20px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <UserPlus size={24} style={{ color: '#8b5cf6' }} />
            <h2 style={{
              margin: 0,
              fontSize: '20px',
              fontWeight: '600',
              color: '#e5e5e5'
            }}>
              Invite Users to {currentRoom.title}
            </h2>
          </div>
          <button
            onClick={onClose}
            style={{
              padding: '8px',
              background: 'transparent',
              border: 'none',
              color: '#888',
              cursor: 'pointer',
              borderRadius: '8px'
            }}
          >
            <X size={20} />
          </button>
        </div>

        {/* Room Info */}
        <div style={{
          background: colors.bgCard,
          borderRadius: '8px',
          padding: '12px',
          marginBottom: '20px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <Users size={16} style={{ color: '#8b5cf6' }} />
          <span style={{ fontSize: '14px', color: '#888' }}>
            Private Room • Only invited users can join
          </span>
        </div>

        {/* Search Input */}
        <div style={{ position: 'relative', marginBottom: '16px' }}>
          <Search size={18} style={{
            position: 'absolute',
            left: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#888'
          }} />
          <input
            type="text"
            placeholder="Search users by username or email..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{
              width: '100%',
              padding: '12px 12px 12px 40px',
              background: colors.bgCard,
              border: '1px solid #333',
              borderRadius: '8px',
              color: 'white',
              fontSize: '14px',
              outline: 'none',
              boxSizing: 'border-box'
            }}
          />
        </div>

        {/* Success Message */}
        {success && (
          <div style={{
            background: 'rgba(16, 185, 129, 0.1)',
            border: '1px solid rgba(16, 185, 129, 0.3)',
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: '#10b981'
          }}>
            <CheckCircle size={16} />
            {success}
          </div>
        )}

        {/* Error Message */}
        {error && (
          <div style={{
            background: 'rgba(239, 68, 68, 0.1)',
            border: '1px solid rgba(239, 68, 68, 0.3)',
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '16px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            color: '#ef4444'
          }}>
            <AlertCircle size={16} />
            {error}
          </div>
        )}

        {/* Search Results */}
        <div style={{
          flex: 1,
          overflowY: 'auto',
          maxHeight: '300px'
        }}>
          {loading && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '40px',
              color: '#888'
            }}>
              <div style={{
                width: '20px',
                height: '20px',
                border: '2px solid #333',
                borderTop: '2px solid #8b5cf6',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                marginRight: '12px'
              }} />
              Searching users...
            </div>
          )}

          {!loading && searchQuery.length >= 2 && searchResults.length === 0 && (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              color: '#888'
            }}>
              <Users size={32} style={{ marginBottom: '12px', opacity: 0.3 }} />
              <p style={{ margin: 0, fontSize: '14px' }}>
                No available users found for "{searchQuery}"
              </p>
              <p style={{ margin: '4px 0 0 0', fontSize: '12px', color: '#666' }}>
                Users may already be members of this room
              </p>
            </div>
          )}

          {searchQuery.length < 2 && (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              color: '#888'
            }}>
              <Search size={32} style={{ marginBottom: '12px', opacity: 0.3 }} />
              <p style={{ margin: 0, fontSize: '14px' }}>
                Start typing to search for users...
              </p>
            </div>
          )}

          {searchResults.map((user) => (
            <div key={user.id} style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '12px',
              background: colors.bgCard,
              borderRadius: '8px',
              marginBottom: '8px',
              border: '1px solid #333'
            }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <img
                  src={user.profile_image_url || `https://api.dicebear.com/7.x/initials/svg?seed=${user.username}`}
                  alt={user.username}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    objectFit: 'cover'
                  }}
                />
                <div>
                  <div style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    color: '#e5e5e5',
                    marginBottom: '2px'
                  }}>
                    {user.username}
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#888'
                  }}>
                    {user.smoker_level} • Member since {new Date(user.created_at).getFullYear()}
                  </div>
                </div>
              </div>

              <button
                onClick={() => inviteUser(user.id, user.username)}
                disabled={inviting[user.id]}
                style={{
                  padding: '8px 16px',
                  background: inviting[user.id] ? '#333' : '#8b5cf6',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: inviting[user.id] ? 'not-allowed' : 'pointer',
                  color: 'white',
                  fontSize: '12px',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  opacity: inviting[user.id] ? 0.7 : 1
                }}
              >
                {inviting[user.id] ? (
                  <>
                    <div style={{
                      width: '12px',
                      height: '12px',
                      border: '2px solid #666',
                      borderTop: '2px solid white',
                      borderRadius: '50%',
                      animation: 'spin 1s linear infinite'
                    }} />
                    Inviting...
                  </>
                ) : (
                  <>
                    <UserPlus size={14} />
                    Invite
                  </>
                )}
              </button>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div style={{
          borderTop: '1px solid #333',
          paddingTop: '16px',
          marginTop: '16px'
        }}>
          <button
            onClick={onClose}
            style={{
              width: '100%',
              padding: '12px',
              background: '#333',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              color: 'white',
              fontSize: '14px',
              fontWeight: '600'
            }}
          >
            Close
          </button>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default InviteUsersModal;